import React from "react";
import { Link } from "react-router-dom";
import { RESOURCES } from "../data/content";
import Icon from "./Icon";
import "../styles/resources.css";

function ResourcesGrid({ limit }) {
  const list = limit ? RESOURCES.slice(0, limit) : RESOURCES;
  return (
    <div className="resources-grid">
      {list.map((res) => (
        <Link to={`/resources/${res.slug}`} className="resources-card" key={res.slug}>
          <span className="resources-card-icon">
            <Icon
              name={
                res.slug === "api-documentation" ? "docs" :
                res.slug === "security" ? "security" :
                res.slug === "testing" ? "testing" :
                res.slug === "deployment" ? "deployment" : "troubleshooting"
              }
              size={20}
            />
          </span>
          <h3 className="resources-card-title">{res.title}</h3>
          <p className="resources-card-detail">{res.detail}</p>
          <span className="resources-card-link">
            Read more <Icon name="arrow" size={14} />
          </span>
        </Link>
      ))}
    </div>
  );
}

export default ResourcesGrid;
